import { Footer } from "../../../components/footers/Footer"
import { FooterBanner } from "../../../components/footers/FooterBanner"
import { HomeHeader } from "../../../components/headers/HomeHeader"
import { RiteCharleeDashboard } from "../../../components/Contents/ritecharleepage/RiteCharleeDashboard"
import { RiteCharleeSections } from "../../../components/Contents/ritecharleepage/RiteCharleeSections"
import { RiteCharleeHero } from "../../../components/heros/RiteCharleeHero"
import { PageMain } from "../../../components/seo/PageMain"
import { PageSeoHelmet } from "../../../components/seo/PageSeoHelmet"
import { STATIC_PAGE_SEO_META } from "../../../components/seo/staticPageSeoMeta"
import SplitType from "split-type"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import TextPlugin from "gsap/TextPlugin"
import { useGSAP } from "@gsap/react"
import { useRef } from "react"

gsap.registerPlugin(useGSAP, ScrollTrigger, TextPlugin)

export const RiteCharlee = () => {
  const riteCharleeRef = useRef()

  useGSAP(
    () => {
      const riteCharleeLogo = gsap.utils.toArray(".riteCharlee-logo")
      const riteCharleeLogoTxt = gsap.utils.toArray(".riteCharlee-logoTxt")
      const riteCharleeHead = gsap.utils.toArray(".riteCharlee-head")
      const riteCharleeText = new SplitType(".riteCharlee-text-inner", {
        types: "lines",
        tagName: "span",
      })
      const riteCharleeBook = gsap.utils.toArray(".riteCharlee-book")
      const riteCharleeBoard = gsap.utils.toArray(".riteCharlee-board")

      const heroTimeline = gsap.timeline()
      heroTimeline.fromTo(
        riteCharleeLogo[0],
        { opacity: 0, clipPath: "circle(0%)" },
        { opacity: 1, clipPath: "circle(100%)", duration: 1 }
      )
      heroTimeline.fromTo(
        riteCharleeLogoTxt[0],
        { opacity: 0, y: 12 },
        { opacity: 1, y: 0, duration: 0.7, ease: "power4.out" },
        "+=0"
      )
      heroTimeline.fromTo(
        riteCharleeHead[0],
        { y: "-100%", opacity: 0 },
        { y: "0%", opacity: 1, duration: 0.9, ease: "power4.out" },
        "+=0"
      )
      heroTimeline.fromTo(
        riteCharleeText.lines,
        { y: "-10%", opacity: 0 },
        { y: "0%", opacity: 1, stagger: 0.05, duration: 0.3 },
        "+=0"
      )
      heroTimeline.fromTo(riteCharleeBook, { opacity: 0 }, { opacity: 1, duration: 0.5 }, "+=0")
      heroTimeline.fromTo(
        riteCharleeBoard[0],
        { clipPath: "inset(100% 0% 0% 0%)", y: "50%", opacity: 0 },
        { clipPath: "inset(0% 0% 0% 0%)", y: "0%", opacity: 1, duration: 0.5 },
        "+=0"
      )

      const sections = [
        ".riteFeature-section",
        ".riteWorks-section",
        ".riteUseCases-section",
        ".riteBusiness-section",
        ".riteSecurity-section",
      ]

      sections.forEach((sectionClass) => {
        const sectionCards = gsap.utils.toArray(`${sectionClass} .rite-card`)

        ScrollTrigger.create({
          trigger: sectionClass,
          start: "-200px bottom",
          end: "bottom top",
          markers: false,
          scrub: 1,
          onEnter: () => {
            const sectionTimeline = gsap.timeline()
            sectionCards.forEach((card) => {
              sectionTimeline.fromTo(
                card,
                { y: "10%", opacity: 0 },
                { y: "0%", opacity: 1, duration: 0.3 },
                "+=0"
              )
            })
          },
        })
      })
    },
    { scope: riteCharleeRef }
  )

  return (
    <>
      <PageSeoHelmet {...STATIC_PAGE_SEO_META.products.ritecharlee} />
      <div className="w-full overflow-hidden bg-[#F9F9F9]">
        <HomeHeader headerColor={'#F9F9F9'} textColor={'#021744'} />
        <PageMain ref={riteCharleeRef} className="riteCharlee-page">
          <RiteCharleeHero />
          <RiteCharleeDashboard />
          <RiteCharleeSections />
        </PageMain>
        <FooterBanner />
        <Footer />
      </div>
    </>
  );
}